//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    imageUrl: String,
    caption: String,
    link: String,
    isHiddenMobile: {
      type: Boolean,
      default: false
    }
  }
}
